import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { DateTime as Luxon } from "luxon";
import DatePicker from 'air-datepicker';
import DatePickerLocaleEN from 'air-datepicker/locale/en';
import DatePickerLocaleFR from 'air-datepicker/locale/fr';
import DatePickerLocaleDE from 'air-datepicker/locale/de';
import DatePickerLocaleES from 'air-datepicker/locale/es';
import Alpine from 'alpinejs';
import * as Tooltip from "tippy.js"

import * as Utils from './utils';
import MobileModal from './Components/MobileModal';
import DesktopModal from './Components/DesktopModal';
import DropdownList from './Components/DropdownList';
import SlidingTabs from './Components/SlidingTabs';

// classes/components
window.Alpine = Alpine;
window.Tabulator = Tabulator;
window.Luxon = Luxon;
// SheetJS (~250 KB gzip) only serves the Excel exports of the grids: fetched on the first export click.
// Tabulator resolves its "XLSX" dependency at download time, from window.XLSX.
window.loadExcel = function () {
    return import(/* webpackChunkName: "xlsx" */ "xlsx").then(function (module) {
        window.Excel = window.XLSX = module;
        return module;
    });
};
window.MobileModal = MobileModal;
window.DesktopModal = DesktopModal;
window.DropdownList = DropdownList;
window.SlidingTabs = SlidingTabs;
window.DatePicker = DatePicker;
window.DatePickerLocale = {
    "en-US": DatePickerLocaleEN,
    "en-CA": DatePickerLocaleEN,
    "en-GB": DatePickerLocaleEN,
    "en-IE": DatePickerLocaleEN,

    "fr-FR": DatePickerLocaleFR,
    "fr-CA": DatePickerLocaleFR,

    "de-DE": DatePickerLocaleDE,
    "de-AT": DatePickerLocaleDE,

    "es-ES": DatePickerLocaleES,
    "es-US": DatePickerLocaleES
};
window.Tooltip = Tooltip;

// functions
window.interpolate = Utils.interpolate;
window.appendHtml = Utils.appendHtml;
window.renderTemplate = Utils.renderTemplate;
window.copyToClipboard = Utils.copyToClipboard;

// vars
window.IsMobileDevice = Utils.isMobileDevice();